var map = {
	"./esports-bg.webp": 1644,
	"./esports-ctg.webp": 1645,
	"./im-img.webp": 1646,
	"./im-title-cn.webp": 1647,
	"./im-title-en.webp": 1648,
	"./object-1.webp": 1649,
	"./object-2.webp": 1650,
	"./object-3.webp": 1651,
	"./object-4.webp": 1652,
	"./tfg-img.webp": 1653,
	"./tfg-title-cn.webp": 1654,
	"./tfg-title-en.webp": 1655,
	"./title-cn.webp": 1656,
	"./title-en.webp": 1657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1643;